//////index///////
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//
//Copy and search starting from "::  Searchable Content  ::"
//
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//1 ::   Sliders  ::
//2 ::   Cover Image  ::
//3 ::   Header  ::
//4 ::   Utilities  ::
//5 ::   Effect on scroll   ::
//6 ::   Page Heroes/Headers   ::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


'use strict';

//This is how codekit adds code when putting together _design.js - in the future these statements will be replaced by imports
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// @codekit-prepend '../../../ncr_library/js/core/functions.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/browser_detection.js'  //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/effect_on_scroll.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/image_to_background.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/move_element_to_another' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/slider.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/smooth_scrolling.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/qty_resize.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/tables.js' //quiet
// @codekit-prepend '../../../ncr_library/js/plugins/tabtrap.js' //quiet
// @codekit-prepend '../../../ncr_library/js/icons/NCR_Icons.js' //quiet
// @codekit-prepend 'icons.js' //quiet

//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


(function ($) {
  $(document).on('ready', function () {
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::				                  
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::													 		              
  //				     Start of Custom JS               :::::::::::::::::::::::::::::  		  
  //						 No custom JS Above this box   	    	 ::::::::::::::::::::::::               
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  //we add our customIcons as well as NCR_Icons, which are found in the NCR_Library, to Font-Awesome, so they can be used
  //
  FontAwesome.library.add(customIcons, NCR_Icons)
  //
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   Sliders  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  // Documentation for Slick
  // https://kenwheeler.github.io/slick/
  //
  //
  //Home Main Slider
  $('.ncr-slider').initiateSlick({
    slider_speed: 9000,
    nextArrow: '<span class="icon-utility-caret-right" aria-label="next" role="img"></span>',
    prevArrow: '<span class="icon-utility-caret-left" aria-label="previus" role="img"></span>'
  });

  // Slider for testimonials-v005
  // $('.feature-wrap-testimonials-1').randomize().slick({
  //   centerMode: true,
  //   slidesToShow: 1,
  //   speed: 1000,
  //   autoplaySpeed: 10000,
  //   autoplay: true,
  //   slide: ".feature",
  //   arrows: true,
  //   fade: true,
  //   nextArrow: '<span class="fas fa-caret-right" aria-label="next" role="img"></span>',
  //   prevArrow: '<span class="fas fa-caret-left" aria-label="previus" role="img"></span>'
  // });

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


  //----------------------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------------///---------------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------------------------//


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   Cover Image  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  //  '.yourClass' all images inside parent will be put on the background-image
  //  css property of their direct parent
  //
  /////////////////////////////////////////////////////////
  //                                                    
  //  $('.yourClass').moveImageToBg({          
  //      //destroyBelow: "600", //default  0            
  //      //bgType: "cover",  // default cover                  
  //      //bgRepeat: "no-repeat", //default no-repeat               
  //      //bgPosition: "center"   //default center                         
  //  });                                                
  //                                                     
  /////////////////////////////////////////////////////////
  //
  //
  //cover image
  $('.cover-image').moveImageToBg({
    bgPosition: 'center center'
  });

  $('.cover-image-special').moveImageToBg({
    bgPosition: 'center center',
    destroyBelow: "600",
    bgType: "cover",
    bgRepeat: "no-repeat"
  });

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


  //----------------------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------------///---------------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------------------------//


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   Header  ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  // You can add tabtrap classes on here using JS or on the HTML directly, but will be a tool within CMS at one point maybe
  // You can use mulitple classes together to create unuique functionality 
  //
  /////// Class List //////
  //
  // panel-overlay - This class will make the panel have an overlay, and if you click anywhere outside of it, it will panel-close
  //
  // panel-pop - This will create a panel with a clickable background and it will stop the scrolling on page, so it can be used as a pop out
  //
  // panel-accordion - This panel is an accordion style panel, if you have muiltple accordions in the same parent, at the same *level
  //
  // switch-1200-overlay-accordion - this class will switch the panel at 1200 from overlay above and accordion below, 
  //                                 you can use any number as the pixel width of browser, 1200 is just an example,
  //                                 you an also use availble type of panel, overylay, accordion, pop, and none
  //
  // panel-off-1200 - This class will turn the panel off and put it back within its normal html flow, as well as put classes on toggle
  //                  so it can be hidden through css. It will be turned off --- ABOVE --- the 1200 ( or any pixel browser width you choose)
  //                  It will then pick up whatever type of panel it is when it gets blow the set pixel browser width
  //
  // panel-cant-close - This will make the panel unclosable through, however if used with panel-accordion, another accordion will
  //                    close it if its on the same level
  //
  // panel-no-trap - This class will make it so once you tap to the end of the panel, instead of tabbing back to the beginning, it goes out
  //                  of the panel and to the next tabbable element on the page
  //
  //

  // //header-v001
  // if ($('.header-v001').length > 0) {
  //   $('.band-menu-panel').addClass('panel-pop panel-off-1200');
  //   $('.band-login-panel').addClass('panel-overlay');
  //   $('.menu-panel-level-2[ncr-panel]').addClass('switch-1200-overlay-accordion');
  //   $('.menu-panel-level-3[ncr-panel]').addClass('panel-off-1200 panel-accordion');
  //   $('header .feature.search [ncr-panel]').addClass('panel-off-1');
  // }
  // //utility 1 to header v001
  // $('.header-v001 .band-utility-1 .feature-wrap').moveElementAround({
  //   insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   //insideAfter: "header .band-menu-panel .feature-wrap-menu",
  //   returnAbove: 1200 
  // })
  

  // //header-v002
  // if ($('.header-v002').length > 0) {
  //   $('.band-menu-panel').addClass('panel-pop');
  //   $('.band-login-panel').addClass('panel-overlay');
  //   $('.menu-panel-level-2[ncr-panel]').addClass('panel-accordion');
  //   $('.menu-panel-level-3[ncr-panel]').addClass('panel-accordion');
  //   $('.header-v002 .feature.search [ncr-panel]').addClass('panel-off-1');

  //   //utility 1 to header v002
  //   $('.header-v002 .band-utility-1 .feature-wrap').moveElementAround({
  //     insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //     //insideAfter: "header .band-menu-panel .feature-wrap-menu",
  //     returnAbove: 9999
  //   })
  // }

  //   //header-v003
  //   if ($('.header-v003').length > 0) {
  //     $('.band-menu-panel').addClass('panel-overlay');
  //     $('.band-login-panel').addClass('panel-overlay');
  //     $('.menu-panel-level-2[ncr-panel]').addClass('panel-off-1200 panel-accordion');
  //     $('.menu-panel-level-3[ncr-panel]').addClass('panel-off-1200 panel-accordion');
  //     $('.header-v003 .feature.search [ncr-panel]').addClass('panel-off-1');
   
  //     //utility 1 to header v003
  //     $('.header-v003 .band-utility-1 .feature-wrap').moveElementAround({
  //       insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //       //insideAfter: "header .band-menu-panel .feature-wrap-menu",
  //       returnAbove: 1200
  //     })
  //   }

  //   // //header-v004
  //   if ($('.header-v004').length > 0) {
  //     $('.band-menu-panel').addClass('panel-pop');
  //     $('.band-login-panel').addClass('panel-off-1200 panel-pop');
  //     $('.menu-panel-level-2[ncr-panel]').addClass('panel-accordion');
  //     $('.menu-panel-level-3[ncr-panel]').addClass('panel-accordion');
  //     $('.header-v004 .feature.search [ncr-panel]').addClass('panel-off-1');
    
  //     //utility 1 to header v004
  //     $('.header-v004 .band-utility-1 .feature-wrap').moveElementAround({
  //       insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //       //insideAfter: "header .band-menu-panel .feature-wrap-menu",
  //       returnAbove: 1200
  //     })
  //   }
    // //header-v005
    if ($('.header-v005').length > 0) {
      $('.band-menu-panel').addClass('panel-off-1200 panel-pop');
      $('.band-login-panel').addClass('panel-pop panel-off-1200');
      $('.menu-panel-level-2[ncr-panel]').addClass('switch-1200-overlay-accordion hover-toggle');
      $('.menu-panel-level-3[ncr-panel]').addClass('panel-off-1200 panel-accordion');
      $('header .feature.search [ncr-panel]').addClass('panel-off-1');
    
      //utility 1 to header v004
      $('header .band-utility-1 .feature-wrap').moveElementAround({
        insideBefore: "header .band-menu-panel .feature-wrap-menu",
        //insideAfter: "header .band-menu-panel .feature-wrap-menu",
        returnAbove: 1185
      })

      //utility 2 to header v004
      $('header .band-utility-2 .feature-wrap').moveElementAround({
        // insideBefore: "header .band-menu-panel .feature-wrap-menu",
        insideAfter: "header .band-menu-panel .feature-wrap-menu",
        returnAbove: 1185
      })
    }
  

    // $('body').designGuides({show:true});
  //panels
  $("body").tabTrapping(); 

  //scrolls to top of menu if menu is opened and has been previously scrolled
  $('.band-menu-panel').on('ncr-panel-opened', function () {
    $('.band-menu-panel').scrollTop(0);
  })



  // $('.band-quicklinks-1 .feature-wrap-inner').qtyResize2()


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


  //----------------------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------------///---------------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------------------------//


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   Utilities  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  //  '.yourClass' is the element that will be moved to a specified element
  ///////////////////////////////////////////////////////////////////////////////////////////
  //                                                    
  //  $('.yourClass').moveElementToAnother({                
  //    // insideBefore: "header .band-menu-panel .feature-wrap-menu", //This will insert '.yourClass' inside the parent of the selected element, --- ABOVE --- the said element
  //    // insideAfter: "header .band-menu-panel .feature-wrap-menu", //This will insert '.yourClass' inside the parent of the selected element, --- BELOW --- the said element
  //    // returnAbove: "1200", // this will return '.yourClass' back to its location --- ABOVE --- 1200px browser width
  //    // returnBelow: "1200" // this will return '.yourClass' back to its location --- BELOW --- 1200px browser width                    
  //  });                                                
  //                                                     
  /////////////////////////////////////////////////////////////////////////////////////////////
  // 


  //utility 1 to header
  // $('header .band-utility-1 .feature-wrap').moveElementAround({
  //   insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   //insideAfter: "header .band-menu-panel .feature-wrap-menu",
  //   returnAbove: 1200 
  // })
  
  // //utility 2 to header
  // $('header .band-utility-2 .feature-wrap').moveElementAround({
  //   insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   //insideAfter: "header .band-menu-panel .feature-wrap",
  //   returnAbove: 1200
  // })
  // //utility 3 to header
  // $('header .band-utility-3 .feature-wrap').moveElementAround({
  //   insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   //insideAfter: "header .band-menu-panel .feature-wrap",
  //   returnAbove: 1200
  // })
  // //utility 4 to header
  // $('header .band-utility-4 .feature-wrap').moveElementAround({
  //   insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   //insideAfter: "header .band-menu-panel .feature-wrap",
  //   returnAbove: 1200
  // })





  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


  //----------------------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------------///---------------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------------------------//


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::   Effect on scroll   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  //  '.yourClass' is the element you would like .nonStick and .stick classs be added to
  /////////////////////////////////////////////////////////////////////////////////////////////
  //                                                              
   $('header.fixed').effectOnScroll({                             
       detectDistance: 0,// default is 0                       
       pushContentDown: true, // default is false                
       fixed: true, // default is false                         
       contentToPush: "main" //default the next element below    
   });             
   
   $('.zone-promos-1 .feature .feature-padding').effectOnScroll({                             
    detectDistance: .2,// default is 0 
  });  

  $('.zone-quicklinks-1 .feature .feature-padding').effectOnScroll({                             
    detectDistance: .3,// default is 0 
  }); 
  //                                                               
  /////////////////////////////////////////////////////////////////////////////////////////////
  //





  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


  //----------------------------------------------------------------------------------------------------------------------------//
  //----------------------------------------------------------///---------------------------------------------------------------//
  //----------------------------------------------------------------------------------------------------------------------------//


  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::   Page Heroes/Headers   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  
   //Moves Breadcrumbs outside of <main> so that you can have a 2 column layout
  // $('.col-main div[class*="breadcrumbs"]').prependTo('main');
  //
  //
  //Moves Content Hero outside of <main> so that you can have a 2 column layout
  $('.col-main div[class*="content-hero"]').prependTo('main');
  //
  //
  //Moves Blog Header outside of <main> so that you can have a 2 column layout
  $('.col-main div[class*="blog-header"]').prependTo('main');

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //
  //
  //
  //
  //
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::				                  
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::													 		              
  //				     End of Custom JS                 :::::::::::::::::::::::::::::  		  
  //						 No custom JS below this box   	    	 ::::::::::::::::::::::::               
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  });
})(jQuery); // or even jQuery.noConflict()